import { StyleSheet } from "react-native"
import { colors, typography } from "theme"

export const style = StyleSheet.create({
  columnWrapper: { flexDirection: "column", width: "100%" },
  container: { height: "100%", padding: 10 },
  contentContainer: {
    backgroundColor: colors.whitePlaceholder,
    borderColor: colors.lighterGrey,
    borderRadius: 25,
    borderWidth: 1,
    flexDirection: "row",
    marginBottom: 20,
    maxHeight: 200,
    padding: 10,
    width: "100%",
  },
  contentTitleText: { marginTop: 10, width: "60%" },
  emptyContainer: {
    alignItems: "center",
    flex: 1,
    justifyContent: "center",
  },
  emptyTitle: {
    fontFamily: typography.primary.normal,
    fontSize: 25,
    padding: 20,
    textAlign: "center",
  },
  flatList: { paddingVertical: 20 },
  flex: { flex: 1 },
  image: {
    alignSelf: "center",
    borderRadius: 20,
    height: "80%", // ensures it takes the height of the container
    width: "80%", // ensures it takes the width of the container
    maxHeight: 150,
    maxWidth: 150,
  },

  imageContainer: {
    alignItems: "center",
    borderRadius: 25,
    height: "100%",
    justifyContent: "center",
    maxHeight: 180,
    maxWidth: 180,
    paddingRight: "5%",
    resizeMode: "contain",
  },
})
